import { Dropdowns } from '@platform/shared/ui';
import { MetadataTypes, ProjectTypes } from '@platform/types';
import React from 'react';
import { useDataSourceLayers } from '../../../../hooks';

interface Props {
  workingLayer: ProjectTypes.SocialExplorerWorkingLayer;
  onChange: (metadata: ProjectTypes.SocialExplorerWorkingLayerMetadata) => void;
}

const SocialExplorerWorkingLayerLevels: React.FC<Props> = ({ onChange, workingLayer }) => {
  const { surveyName, datasetAbbreviation, isUserSurvey } =
    workingLayer.metadata as ProjectTypes.SocialExplorerWorkingLayerMetadata;

  const dataSourceLayersQuery = useDataSourceLayers(surveyName, isUserSurvey);
  if (dataSourceLayersQuery.isLoading || dataSourceLayersQuery.isIdle) return null;
  if (dataSourceLayersQuery.isError) return null;

  const options: Dropdowns.DropdownOption[] = dataSourceLayersQuery.data.map((x) => ({
    value: x['geo-layer-id'],
    name: x['summary-level'].title.replace('Data: ', ''),
  }));

  const apply = (dataSourceLayer: MetadataTypes.MetadataSocialExplorerDataSourceLayer) => {
    const dataset = dataSourceLayer.datasets.find((ds) => ds['dataset-abbreviation'] === datasetAbbreviation);

    if (!dataset) {
      console.error('no dataset');
      return;
    }

    onChange({
      ...workingLayer.metadata,
      geoLayerId: dataSourceLayer['geo-layer-id'],
      dataLayerId: dataset['dataset-id'],
      identifiers: {
        row: {
          datasetId: dataset['dataset-id'],
          variableId: dataset['primary-key-column'] ?? '0',
        },
        name: {
          datasetId: dataset['dataset-id'],
          variableId: dataset['geo-qualified-name-column'] ?? '0',
        },
      },
    });
  };

  const handleDropdownSelect = (option: Dropdowns.DropdownOption) => {
    const dataSourceLayer = dataSourceLayersQuery.data.find((x) => x['geo-layer-id'] === option.value);
    if (!dataSourceLayer) {
      console.error('DATASOURCE LAYER MISSING');
      return;
    }
    apply(dataSourceLayer);
  };

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-1">
        Level:
        <Dropdowns.Dropdown
          options={options}
          onSelect={handleDropdownSelect}
          value={workingLayer.metadata.geoLayerId}
        />
      </div>
    </div>
  );
};

export default SocialExplorerWorkingLayerLevels;
